import * as React from 'react';
import * as RadioGroupPrimitive from '@radix-ui/react-radio-group';
import { CircleIcon } from 'lucide-react';
import { cn } from '@lib/utils';

function RadioGroup({
  className,
  ...props
}: React.ComponentProps<typeof RadioGroupPrimitive.Root>) {
  return (
    <RadioGroupPrimitive.Root
      className={cn('grid gap-2', className)}
      data-slot="radio-group"
      {...props}
    />
  );
}

function RadioGroupItem({
  className,
  ...props
}: React.ComponentProps<typeof RadioGroupPrimitive.Item>) {
  return (
    <RadioGroupPrimitive.Item
      className={cn(
        'border-[white] text-white focus-visible:border-ring focus-visible:ring-ring/50 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive aspect-square size-4 shrink-0 rounded-full border-[2px] shadow-xs transition-[color,box-shadow] outline-none focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50',
        className
      )}
      data-slot="radio-group-item"
      {...props}
    >
      <RadioGroupPrimitive.Indicator
        className="relative flex items-center justify-center"
        data-slot="radio-group-indicator"
      >
        <CircleIcon className="fill-secondary absolute top-1/2 left-1/2 size-2 -translate-x-1/2 -translate-y-1/2" />
      </RadioGroupPrimitive.Indicator>
    </RadioGroupPrimitive.Item>
  );
}

interface SingleRadioProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  checked?: boolean;
  label?: string;
}

function SingleRadio({
  checked = false,
  label,
  className,
  ...props
}: SingleRadioProps) {
  return (
    <div className={'flex gap-x-2 items-center'}>
      <button
        aria-checked={checked}
        className={cn(
          'border-[white] text-white aspect-square size-4 shrink-0 rounded-full border-[2px] shadow-xs transition-[color,box-shadow] outline-none disabled:cursor-not-allowed disabled:opacity-50 items-center justify-center flex',
          className
        )}
        role="radio"
        type="button"
        {...props}
      >
        {checked && <CircleIcon className="fill-secondary size-2" />}
      </button>
      {label ? <p>{label}</p> : null}
    </div>
  );
}

export { RadioGroup, RadioGroupItem, SingleRadio };
